import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  NumberField,
  BulkDeleteWithConfirmButton,
  useTheme,
} from "react-admin";
import accountReceivableCorrectionFilterList from "../../components/accountReceivableCorrections/filter/accountReceivableCorrectionFilterList";
import AccountReceivableCorrectionExpandList from "../../components/accountReceivableCorrections/expand/AccountReceivableCorrectionExpandList";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountReceivableCorrectionFooterList from "../../components/accountReceivableCorrections/footer/AccountReceivableCorrectionFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountReceivableCorrectionList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.list_title.account_receivable_correction"
        empty={false}
        actions={<DownloadAction />}
        filters={accountReceivableCorrectionFilterList(permissions)}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          body={
            <MyDatagridBody
              footer={<AccountReceivableCorrectionFooterList />}
            />
          }
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
          expand={<AccountReceivableCorrectionExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.depo" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField source="customer.code" label="mine.label.customer_code" />
          <TextField source="customer.name" label="mine.label.customer" />
          <NumberField source="total" />
          <TextField source="note" label="mine.label.note" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default AccountReceivableCorrectionList;
